import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';
import * as fromRoot from '../reducers';

@Injectable({
  providedIn: 'root',
})
export class AuthFacade {
  public readonly token$ = this.store.select(fromRoot.getToken);

  constructor(private store: Store<fromRoot.State>) {}

  public setToken(token: string | null | undefined): void {
    this.store.dispatch(AuthActions.setTokenAction({ payload: { token } }));
  }
}
